import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { VehicleListTemplateComponent } from '../template/vehicle-list-template/vehicle-list-template.component';
import { LocationListTemplateComponent } from '../template/location-list-template/location-list-template.component';
import { ServicePackageListTemplateComponent } from '../template/service-package-list-template/service-package-list-template.component';
import { UserListTemplateComponent } from '../template/user-list-template/user-list-template.component';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {

  @Input()
  servicePackageList: Array<any>;
  @Input()
  vehicleList: Array<any>;
  @Input()
  services: Array<any>;
  @Input()
  locationList: Array<any>;
  @Input()
  usageList: Array<any>;
  @Input()
  locationMap: Map<string, any>;
  @Input()
  deviceList: Array<any>;
  @Input()
  userList: Array<any>;

  selectedItem: Array<string> = ['SERVICE', 'SERVICE_PACKAGE', 'VEHICLE', 'LOCATION', "USAGE", "USER"];

  selectedItemForView: string = '';
  isCloseDetailClicked: boolean = true;
  isViewDetail: boolean = false;

  @Output() selectedItemEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedItemCloseEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('locationListTemplate') locationListTemplate:LocationListTemplateComponent;
  @ViewChild('vehicleListTemplate') vehicleListTemplate:VehicleListTemplateComponent;
  // @ViewChild('serviceListTemplate') serviceListTemplate:ServiceListTemplateComponent;
  @ViewChild('servicePackageListTemplate') servicePackageListTemplate:ServicePackageListTemplateComponent;
  @ViewChild('userListTemplate') userListTemplate:UserListTemplateComponent;

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.getNonPendingUsage();
  }

  selectedItemToView(data) {
    console.log("Selected item to view::", data);
    this.isCloseDetailClicked = false;
    this.selectedItemForView = data.key;
    this.selectedItemEmitter.emit(data.navText);
  }

  closeViewItem(data) {
    console.log("Close the view of item.");
    this.selectedItemForView = '';
    this.isCloseDetailClicked = true;
    this.selectedItemCloseEmitter.emit();
  }

  onNavSearchClick() {
    if(this.selectedItemForView == this.selectedItem[2])
      this.vehicleListTemplate.closeVehicleDetailClicked(null);
    // else if(this.selectedItemForView == this.selectedItem[0])
    //   this.serviceListTemplate.closeOfViewClicked(null);
    else if(this.selectedItemForView == this.selectedItem[1])
      this.servicePackageListTemplate.closePackageDetailClicked(null);
    // else if(this.selectedItemForView == this.selectedItem[3]) {
    //   this.locationListTemplate.closeOfViewClicked(null);
      // this.accountList = this.accountService.searchedAccounts;
    // }
  }

  getNonPendingUsage() {
    var usageList = new Array();
    if(this.usageList) {
      this.usageList.forEach(usage => {
        if(usage.operationStatus != 'PENDING') {
          usageList.push(usage);
        }
      });
    }
    this.usageList = usageList;
  }

}
